module.exports = __webpack_public_path__ + "static/media/cabin.56ec4ee7.png";